module.exports = [
	"#ff0000",
	"#ff4000",
	"#ff8000",
	"#ffbf00",
	"#ffff00",
	"#bfff00",
	"#80ff00",
	"#40ff00",
	"#00ff00",
	"#00ff40",
	"#00ff80",
	"#00ffbf",
	"#00ffff",
	"#00bfff",
	"#0080ff",
	"#0040ff",
	"#0000ff",
	"#4000ff",
	"#8000ff",
	"#bf00ff",
	"#ff00ff",
	"#ff00bf",
	"#ff0080",
	"#ff0040",
	"#ff0000",
	"#ff0000",
	"#f90606",
	"#f20d0d",
	"#ec1313",
	"#e61919",
	"#df2020",
	"#d92626",
	"#d22d2d",
	"#cc3333",
	"#c63939",
	"#bf4040",
	"#b94646",
	"#b34d4d",
	"#ac5353",
	"#a65959",
	"#9f6060",
	"#996666",
	"#936c6c",
	"#8c7373",
	"#867979",
	"#808080",
	"#ffe6e6",
	"#ffcccc",
	"#ffb3b3",
	"#ff9999",
	"#ff8080",
	"#ff6666",
	"#ff4d4d",
	"#ff3333",
	"#ff1a1a",
	"#ff0000",
	"#e60000",
	"#cc0000",
	"#b30000",
	"#990000",
	"#800000",
	"#660000",
	"#4d0000",
	"#330000",
	"#1a0000",
	"#000000"
];


//////////////////
// WEBPACK FOOTER
// ./src/core/constant/colors.json
// module id = 122
// module chunks = 0